import React , { Component } from 'react';
import HOC from './HOC';
import InputText from '../components/formulario/InputText';
import { CONSTANTES } from '../utils/Constantes';
import Select from '../components/formulario/Select';
import Radio from '../components/formulario/Radio';
import Boton from '../components/formulario/Boton';
import Utils from '../utils/Validate';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col';
import Popover from 'react-bootstrap/Popover';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-responsive-modal';
import ReactTable from 'react-table';
import {ReactTableDefaults} from 'react-table';
import 'react-table/react-table.css';
import 'jsoneditor-react/es/editor.min.css';
import moment from 'moment';
import { Auth, Storage } from 'aws-amplify';
import ModalGenerico from '../components/comunes/ModalGenerico';
import Footer from '../components/comunes/Footer';
import Breadcrumb from '../components/comunes/Breadcrumb';
import selectTableHOC from "react-table/lib/hoc/selectTable";
const SelectedTable = selectTableHOC(ReactTable);

class GestionAtributos extends Component {
    state = {
        listaAtributos   : [],
        listaSubAtributos   : [],
        tampagina   : 3,
        isLoading       : false,
        m_modal         : '',
        casoModal: '',
        pagination: 10,        
        
        open: false,
        openLista: false,
        disabledEliminar: true,
        //Agregando Nuevo
        
        usuario: '',
        formatoAtributo: 'texto||Texto',
        nombreAtributo: '',
        codAtributo: '',
        tipoDato: "",

        v_formatoAtributo: true,       
        v_nombreAtributo: true,
        v_codAtributo: true,
        v_tipoDato: true,

        d_tipoDato: false,

        listaFormato: [
            {
                name:"formatoAtributo",
                value: 'texto',            
                detalle: 'Texto'
            },
            {
                name:"formatoAtributo",
                value: 'lista',            
                detalle: 'Lista Desplegable'
            }
		],
		listaTipoDato: [
            {
                value: "String",
                detalle: 'Alfanumérico'
            },
            {
                value: "Number",
                detalle: 'Numérico'
            }
        ],
        actAtributo: {},        
        /***********subatributo**********/
        nombreSubAtributo: '',
        v_nombreSubAtributo: true,
        eliminarSubAtributo: []
    }
  
    
    previousPageHandler = () => {
        this.setLocalStorage("FLUJO","1");
        this.props.props.history.push({ pathname : CONSTANTES.RUTA.detalle });
    }

    onOpenModalSubAtributos =  (atributo)  => {        
        this.setState({ openLista: true, actAtributo : atributo, disabledEliminar: true}, ()=>this.consultarSubAtributos());  
    };

    onCloseModal = ()  => {
        this.setState({ open: false, openLista: false });
    };

    setLocalStorage = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
      }
    
      getLocalStorage = (key) => {
        if(localStorage.hasOwnProperty(key)){
          const local = localStorage.getItem(key);
          return JSON.parse(local);
        }else{
          return {};
        }
        
      }

    componentWillMount() {
    }

    async componentDidMount(){
		if("true" !== localStorage.getItem('login')){
            await Auth.signOut();
        }
        
        Auth.currentUserInfo().then(response => {
            if (response && response.attributes != null){
              this.setState({
                usuario: response && response.attributes.email ? response.attributes.email : ''
              });
            }
        });
        this.iniciarOpciones();
        await this.consultarAtributos();
        this.setState({codAtributo: Utils.generarCodigoAtributo(this.state.listaAtributos)});
    }
    iniciarOpciones = () =>{
        let opciones= this.getLocalStorage('permisos');
        this.setState({opciones: opciones, accionDefault: ''});
    }
    timer = () => {
        Auth.currentSession().then(response =>{
            var exp = moment.unix(response.accessToken.payload.exp).format('DD/MM/YYYY hh:mm:ss');
            var fecha_actual = moment(new Date()).format('DD/MM/YYYY hh:mm:ss');
            if(fecha_actual > exp){
                this.cerrarSesion();
            }
		})
		.catch(error =>{
			this.props.props.history.push({ pathname : CONSTANTES.RUTA.login }); 
		});
    }
    limpiarFormulario = () =>{
        this.setState({ formatoAtributo: 'texto||Texto',
                        nombreAtributo: '',
                        codAtributo: Utils.generarCodigoAtributo(this.state.listaAtributos),
                        tipoDato: 'String||Alfanumérico'});
    }
    validarFormulario = (e) => {
        let response = true;
        if (this.state.formatoAtributo == '||' || !this.state.v_formatoAtributo){
            this.setState({v_formatoAtributo:false});
            response = false;
        }else{
            this.setState({v_formatoAtributo:true})
        }
        if (this.state.nombreAtributo == '' || !this.state.v_nombreAtributo){
            this.setState({v_nombreAtributo:false});
            response = false;
        }else{
            this.setState({v_nombreAtributo:true})
        }
        if (this.state.codAtributo == '' || !this.state.v_codAtributo){
            this.setState({v_codAtributo:false});
            response = false;
        }else{
            this.setState({v_codAtributo:true})
        }
        
        if ((!this.state.d_tipoDato)  && ((this.state.tipoDato == '||' || this.state.tipoDato == '') || !this.state.v_tipoDato)){
            this.setState({v_tipoDato:false});
            response = false;
        }else{
            this.setState({v_tipoDato:true})
        }
        
        return response;
    }
    validarCampo = (e, callback) => {
        let { value , name, valorDependiente } = e.target;
        this.setState({['v_' + name] : Utils.validarCampo(name, value, valorDependiente)}, () => {
            if (callback) callback();
        });  
    }
    onChange = (e) => {
        let { name, value } = e.target;
        this.setState({ [name] : value }, () => {
        });        
    }
    onDisabled = (e) =>{
        let { name, value } = e;
        this.setState({['d_' + name] : value , [name] : ''}, () => {
            if(name=='tipoDato')
                this.setState({[name] : 'String||Alfanumérico'});
        });
    }
    cerrarSesion = () => {
        this.props.mostrarLoading();      
        new Promise((resolve, reject) => {
          setTimeout(function(){
			//localStorage.clear();
			
            resolve(true);
          },500)
        }).then(() => {
          this.props.ocultarLoading();
          this.props.props.history.push({ pathname : CONSTANTES.RUTA.login });
        })
    }
    /** OBTENER REMESAS */
    consultarAtributosService = async (params) => {
        this.props.mostrarLoading();
        return new Promise((resolve, reject)=>{
            this.props.props.callServiceUsuarios("GET","atributos", {...params}).then(response => {
                // console.log(response);
                if(response){
                    console.log(response);
                    if(200 === response.statusCode && 0 === response.body.responseCode){
                        let atributos = [];
                        atributos = response.body.data.attributes;
                        let listaAtributos = atributos;
                        this.setState({
                            tampagina: listaAtributos.length==0?3:listaAtributos.length,
                            listaAtributos:listaAtributos                        
                        }, () => {
                            resolve(true);
                        });
                    }else{
                        this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                        resolve(true);
                    }
                    this.props.ocultarLoading();
                }
            }).catch( error => {
                console.error(error);
                this.props.ocultarLoading();
                this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
                reject(error);
            });
        }); 
    }  

    consultarAtributos = async () => {
        let request = {
                      
        };
        await this.consultarAtributosService(request);
    }
    buscar = () => {
        if(this.validarFormulario())
            this.consultarUsuarios(true);
    }

    crearAtributoService =  (params) => {
        this.props.mostrarLoading();
        this.props.props.callServiceUsuarios("POST","atributos", {...params}).then(async response => {
            // console.log(response);
            this.props.ocultarLoading();
            this.setState({open: false});
            if(response){
                console.log(response);
                if(200 === response.statusCode && 0 === response.body.responseCode){                                       
                    this.props.mostrarModal('mensaje', null, 'Se creó el atributo satisfactoriamente.');
                    await this.consultarAtributos();
                    this.limpiarFormulario();
                    if(response.body.data.format == 'lista')
                        this.onOpenModalSubAtributos(response.body.data); 
                }else{
                    this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                }
                
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }
    crearAtributo = () => {
        let request = {
            payload: {
                attributeName : this.state.nombreAtributo,
                format : this.state.formatoAtributo.split(CONSTANTES.SEPARADOR)[0],
                code : this.state.codAtributo,
                datatype : this.state.tipoDato.split(CONSTANTES.SEPARADOR)[0]                  
                }
            };
               
        this.crearAtributoService(request);
    } 
    crearAtributoConfirmar = () => {
        if(this.validarFormulario())       
            this.setState({ open: true});
    }
    /*******SUBATRIBUTOS*****/
    limpiarFormularioSubAtributo = () =>{
        this.setState({ nombreSubAtributo: ''});
    }
    validarFormularioSubAtributo = (e) => {
        let response = true;        
        if (this.state.nombreSubAtributo == '' || !this.state.v_nombreSubAtributo){
            this.setState({v_nombreSubAtributo:false});
            response = false;
        }else{
            this.setState({v_nombreSubAtributo:true})
        }                
        return response;
    }
    crearSubAtributoService = (params) => {
        this.props.mostrarLoading();
        this.props.props.callServiceUsuarios("POST","atributos/"+this.state.actAtributo.key+"/subatributos", {...params}).then(response => {
            // console.log(response);
            this.props.ocultarLoading();
            //this.setState({open: false});
            if(response){
                console.log(response);
                if(200 === response.statusCode && 0 === response.body.responseCode){
                    this.limpiarFormularioSubAtributo();
                    this.props.mostrarModal('mensaje', null, 'Se creó el sub atributo satisfactoriamente.');
                    this.consultarSubAtributos();
                }else{
                    this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                }
                
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }
    crearSubAtributo = () => {
        if(this.validarFormularioSubAtributo()){
            let request = {
                payload: {
                    subattributeName : this.state.nombreSubAtributo                                 
                    }
                };               
            this.crearSubAtributoService(request);
        }        
    }
    consultarSubAtributosService = (params) => {
        this.props.mostrarLoading();
        this.props.props.callServiceUsuarios("GET","atributos/"+this.state.actAtributo.key, {...params}).then(response => {
            // console.log(response);
            if(response){
                console.log(response);
                if(200 === response.statusCode && 0 === response.body.responseCode){
                    let subAtributos = [];
                    subAtributos = response.body.data.attribute.subAttributes;
                    let listaSubAtributos = subAtributos.map(e=>{e['_id']=e.key;
                                                                 return e;});
                    this.setState({
                        tampagina: listaSubAtributos.length==0?3:listaSubAtributos.length,
                        listaSubAtributos:listaSubAtributos,
                        eliminarSubAtributo:[]                        
                    }, () => {
                    });
                }else{
                    this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                }
                this.props.ocultarLoading();
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }  

    consultarSubAtributos = () => {
        let request = {
                      
        };
        this.consultarSubAtributosService(request);
    }
    /*****SUBATRIBUTO ELIMINAR*** */
    limpiarFormularioEliminarSubAtributo = () =>{
        this.setState({ eliminarSubAtributo: []});
    }
    validarFormularioEliminarSubAtributo = (e) => {
        let response = true;        
        if (this.state.eliminarSubAtributo.length == 0 ){
            this.props.mostrarModal('mensaje', null, 'Seleccione un sub atributo.');          
            response = false;
        }else{            
        }                
        return response;
    }
    eliminarSubAtributoService = (params) => {
        this.props.mostrarLoading();
        this.props.props.callServiceUsuarios("DELETE","atributos/"+this.state.actAtributo.key+"/subatributos/"+this.state.eliminarSubAtributo[0], {...params}).then(response => {
            // console.log(response);
            this.props.ocultarLoading();
            //this.setState({open: false});
            if(response){
                console.log(response);
                if(200 === response.statusCode && 0 === response.body.responseCode){
                    this.limpiarFormularioEliminarSubAtributo();
                    this.props.mostrarModal('mensaje', null, 'Se eliminó el sub atributo satisfactoriamente.');
                    this.consultarSubAtributos();
                }else{
                    this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                }
                
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }
    eliminarSubAtributo = () => {
        if(this.validarFormularioEliminarSubAtributo()){
            let request = {
                
                };               
            this.eliminarSubAtributoService(request);
        }        
    }
    render=()=>{
        const fontSize = 11;
        var { open, openLista,  listaAtributos, listaSubAtributos, page } = this.state;
        ReactTableDefaults.column= {...ReactTableDefaults.column, headerClassName: 'tableUserHeader', className:'tableUserCell'};
        //ReactTableDefaults.columnHeaderProps= {...ReactTableDefaults.columnHeaderProps, headerClassName: 'tableUserHeader2', className:'tableUserCell2'};
        let columns = [{
            id: 'id',
            Header: 'ID',
            accessor: 'id',
            show: false
        }, {
            Header: 'CÓDIGO ATRIBUTO',
            accessor: 'code',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 90,
            style: {
                fontSize: fontSize,
            }
        }, {
            Header: 'NOMBRE DE ATRIBUTO',
            accessor: 'name',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 130,
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'FORMATO DE ATRIBUTO',
            accessor: 'format',
            Cell: props => <div style={{ textAlign: "center" }}>{this.state.listaFormato.filter(e=>props.value==e.value)[0].detalle}</div>,
            minWidth: 120,
            style: {
                fontSize: fontSize,
            },
        },  {
            Header: 'TIPO DE DATO',
            accessor: 'datatype',
            Cell: props => <div style={{ textAlign: "center" }}>{props.original.format=='texto'?props.value:''}</div>,
            minWidth: 80, 
            style: {
                fontSize: fontSize,
            },
        }, {
            Header: 'LISTA DEL ATRIBUTO',
            Cell: props => 
            {
                if(props.original.format == 'lista') 
                    return(<div style={{ textAlign: "center", fontSize: 10 }}>
                            <button type="button" className="btn btn-table btn-primary red" onClick={()=>this.onOpenModalSubAtributos(props.original)}>VER LISTA
                            </button>
                            </div>);
                else
                    return null;
            }
            ,
            filterable: false,
            minWidth: 70,
            style: {
                fontSize: fontSize,
            }
        }];        
        let columnsAtributos = [
            {id:'_selector', show:false},
        /*{
            Header: 'SELECCIONAR',
            accessor: 'key',
            Cell: props => <div style={{ textAlign: "center" }}>
                            <Form.Check inline name="key" type={"checkbox"} id={`inline-radio-1`} />
                        </div>,
            minWidth: 100,
            style: {
                fontSize: fontSize,
            }
        }, */{
            Header: 'NOMBRE DE SUB ATRIBUTO',
            accessor: 'name',
            Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div>,
            minWidth: 390,
            style: {
                fontSize: fontSize,
            },
        }];
        return(
            <section className="showMntUsuarios container-fluid container-filtercolor">
                    <div className="container container-filter justify-content-start mb-flex-column">
                        <div className="container-filter-info justify-content-start mb-full">
                            <div className="">
                            <Breadcrumb opciones={this.state.opciones} accionActual={""} accionDefault={""}  irDefault={()=>{}}/>
                                <h1>Gestión de <b>atributos</b></h1>
                                <p>Aquí gestiona la creación de atributos para el Portal.</p>                               
                            </div>                            
                        </div>                       
                                                
                    </div>
                    <div className="container-fluid d-flex mb-flex-column justify-content-between">
                        <div className={"container boxBuscar mb-w100 d-flex flex-column flex-justify-between w100"}>
                            <div className="seccionFiltrar">
                                <Row>
                                    <Col className="s12 m3 l2 div-subtitulo" style={{float: "left"}}>
                                        Crear Atributo
                                    </Col>
                                </Row>
                                <Row>
                                    {/*<div key={`inline-radio`} className="mb-3">
                                        <Col className="s12 m12 l12 div-lbl-radio" style={{float: "left" }}>
                                            Elegir el formato del atributo
                                        </Col>
                                        <Form.Check inline label="Texto" name="group1" type={"radio"} id={`inline-radio-1`} />
                                        <Form.Check inline label="Lista Desplegable" name="group1" type={"radio"} id={`inline-radio-2`} />
                                    </div>*/}
                                    <Col className="s12 m12 l12" >
                                            <Radio
                                            titulo="Elegir el formato del atributo"
                                            opciones={this.state.listaFormato}                                                
                                            clase="div-lbl-radio"
                                            onChange={(e) => { 
                                                this.onChange(e); 
                                                this.validarCampo(e);
                                                this.onDisabled({name:'tipoDato', value:(e.target.value == 'texto||Texto')? false:true});                                                                                                
                                            }}
                                            value={this.state.formatoAtributo}
                                            tipo={"horizontal"}
                                            validate={this.state.v_formatoAtributo}
                                                />
                                    </Col>
                                </Row>                                
                                <Row className={"row-form-v2"}>
                                    <Col className="s12 m6 l4" >
                                        <InputText
                                            name="codAtributo"
                                            placeholder="Código de Atributo"
                                            value={this.state.codAtributo}
                                            onBlur={this.validarCampo} 
                                            onChange={this.onChange}
                                            validate = {this.state.v_codAtributo}                                            
                                            clase = {"input-v2"} 
                                            disabled={true} 
                                            />
                                        <span className={'msj'}>Máximo de 25 atributos</span>
                                    </Col> 
                                    <Col className="s12 m6 l4" >
                                            <InputText
                                                name="nombreAtributo"
                                                placeholder="Nombre de Atributo"
                                                value={this.state.nombreAtributo}
                                                onBlur={(e)=>{
                                                        e.target.valorDependiente = (!this.state.d_tipoDato)?this.state.tipoDato.split(CONSTANTES.SEPARADOR)[0]:null;
                                                        this.validarCampo(e);                                                        
                                                        }
                                                        }
                                                onChange={this.onChange}
                                                validate = {this.state.v_nombreAtributo}
                                                clase = {"input-v2"}
                                                maxLength={15}  />
                                    </Col> 
                                    <Col className="s12 m3 l2">
                                            <Select 
                                                lista = {this.state.listaTipoDato}                                                 
                                                titulo = "Tipo de Dato"                                                
                                                name = "tipoDato"
                                                habilitarValorInicial = {false}
                                                value = {this.state.tipoDato}
                                                onChange = {(e) => { 
                                                                    this.onChange(e);                                                                     
                                                                    this.validarCampo(e,()=>
                                                                        this.validarCampo({target:{name: 'nombreAtributo', value: this.state.nombreAtributo, valorDependiente: (!this.state.d_tipoDato)?this.state.tipoDato.split(CONSTANTES.SEPARADOR)[0]:null}}));
                                                                                                                                        

                                                            }}
                                                placeholder = 'Tipo de Dato'
                                                validate = {this.state.v_tipoDato}
                                                disabledSelect = {this.state.d_tipoDato}/>
                                    </Col>                      
                                    
                                    <Col className="s12 m3 l2" style={{float: "left"}}>
                                        <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.crearAtributoConfirmar} style={{marginBottom: "10px"}}>CREAR</button>
                                    </Col>
                                </Row>                                      
                                <Row>
                                    <Col className="s12 m3 l2 div-subtitulo" style={{float: "left"}}>
                                            Lista de atributos
                                    </Col> 
                                    <Col className="s12 m2 l1 form-filtro" style={{float: "right"}}>
                                        TOTAL: {listaAtributos.length}
                                    </Col>
                                </Row>
                                                                        
                                <div>
                                    <ReactTable
                                            className={"-striped"}
                                            style={{backgroundColor : "white"}}                                            
                                            data={listaAtributos}
                                            defaultPageSize={3}
                                            columns={columns}
                                            showPagination= {false}                                            
                                            //pageSize={this.state.tampagina}
                                            loadingText={"Cargando..."}
                                            noDataText={"No hay datos para mostrar"}
                                            //pageText={"Página"}
                                            //ofText={"de"}
                                            //rowsText={"filas"}
                                            //pageSizeOptions={[10, 20, 50]}
                                            manual
                                            //page={page}
                                            //pages={this.state.pages}
                                            //sorted={this.state.sorted}
                                            // onPageChange={page => this.setState({ page })}
                                            
                                            getNoDataProps={(state, rowInfo, column) => {
                                                return {
                                                  style: {
                                                    background: 'none',
                                                    top: '63%'
                                                  }
                                                }
                                              }}                                               
                                    />
                                </div>                                
                            </div>
                        </div>
                        <Modal open={open} onClose={this.onCloseModal} center classNames={{modal: 'modal-sm'}} >                            
                                <div className="header-modal-usuario">
                                    CREACIÓN DE ATRIBUTO
                                </div>
                                <div className="body-modal-usuario">                                       
                                <Row  className="div-modal-det" style={{margin: "auto", float: "none"}}>    
                                    <Col  className="s12 m12 l12 div-subtitulo-modal" style={{float: "left"}}>
                                        ¿Estas seguro de realizar la creación del atributo?
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left", fontWeight: "bold"}}>
                                        Nota: No se podrá eliminar el atributo creado
                                    </Col>                                    
                                </Row>
                                <Row>
                                    <Col className="s12 m6 l4" style={{margin: "auto", float: "left"}}>
                                            <button className={"botonFormulario right btn-small btn-g no-box-shadow"} onClick={this.onCloseModal}  style={{marginBottom: "10px"}}>CANCELAR</button>
                                    </Col>
                                    <Col className="s12 m6 l4" style={{margin: "auto", float: "right"}}>
                                            <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.crearAtributo} Style={{marginBottom: "10px"}}>CONFIRMAR</button>
                                    </Col>
                                </Row>
                                </div>
                        </Modal>
                        <Modal open={openLista} onClose={this.onCloseModal} center  classNames={{modal: 'modal-mm'}}>                            
                                <div className="header-modal-usuario">
                                    LISTA DEL ATRIBUTO: {this.state.actAtributo.code && (this.state.actAtributo.code.toUpperCase() +' '+this.state.actAtributo.name.toUpperCase())}
                                </div>
                                <div className="body-modal-usuario">                                       
                                <Row  className="div-modal-det" style={{margin: "auto", float: "none"}}>    
                                    <Col  className="s12 m12 l12 div-subtitulo-modal" style={{float: "left"}}>
                                        Crear Sub Atributo
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left", fontWeight: "bold"}}>
                                        <InputText
                                                name="nombreSubAtributo"
                                                placeholder="Descripción de Sub Atributo"
                                                value={this.state.nombreSubAtributo}
                                                onBlur={this.validarCampo} 
                                                onChange={this.onChange}
                                                validate = {this.state.v_nombreSubAtributo}                                            
                                                clase = {"input-v2"}  />
                                    </Col>                                    
                                </Row>
                                <Row  style={{marginBottom: "5px"}}>
                                    <Col className="s12 m6 l4" style={{margin: "auto", float: "left"}}>
                                            <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.eliminarSubAtributo}  style={{marginBottom: "10px"}} disabled={this.state.disabledEliminar}>ELIMINAR</button>
                                    </Col>
                                    <Col className="s12 m6 l4" style={{margin: "auto", float: "right"}}>
                                            <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.crearSubAtributo} Style={{marginBottom: "10px"}} >CREAR</button>
                                    </Col>
                                </Row>
                                </div>
                                <SelectedTable
                                    selectWidth={120}
                                    className={"-striped"}
                                    style={{backgroundColor : "white", height: "40vh"}}                                            
                                    data={listaSubAtributos}
                                    defaultPageSize={5}
                                    columns={columnsAtributos}
                                    showPagination= {false} 
                                    SelectAllInputComponent = {()=>"SELECCIONAR"}
                                    loadingText={"Cargando..."}
                                    noDataText={"No hay datos para mostrar"}
                                    //pageText={"Página"}
                                    //ofText={"de"}
                                    //rowsText={"filas"}
                                    //pageSizeOptions={[10, 20, 50]}
                                    manual

                                    isSelected= {(key) => {
                                        return this.state.eliminarSubAtributo.includes(key); 
                                    }                 
                                    }
                                    toggleSelection = {(key, shift, row) => {
                                        let eliminarSubAtributo = [...this.state.eliminarSubAtributo];
                                        //const keyIndex = selection.indexOf(key);                    
                                        eliminarSubAtributo = [key.split('-')[1]];
                                        this.setState({ eliminarSubAtributo , disabledEliminar: false});

                                        console.log(this.props.mensaje);
                                        //if("select-"+this.props.mensaje[0].numDocumento==key){                                        
                                    }}
                                    selectType = "checkbox"
                                    
                                    //page={page}
                                    //pages={this.state.pages}
                                    //sorted={this.state.sorted}
                                    // onPageChange={page => this.setState({ page })}
                                    getNoDataProps={(state, rowInfo, column) => {
                                        return {
                                          style: {
                                            background: 'none',
                                            top: '63%'
                                          }
                                        }
                                      }} 
                                    //SelectInputComponent = {}                                            
                                />
                                <br/>
                                 <Row> 
                                    <Col className="s12 m12 l12 form-filtro" style={{textAlign: "right"}}>
                                        TOTAL: {listaSubAtributos.length}
                                    </Col>
                                </Row>         
                        </Modal>                                    
                    </div>   
            </section>                          
           
        );
    }
}
export default HOC(GestionAtributos);